/**
 * BrewNectar Compare Page Hero — fade-up + smooth anchor scroll
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function resolveHashTarget(href) {
    if (!href) return null;

    if (href.charAt(0) === '#') {
      return document.querySelector(href);
    }

    try {
      var url = new URL(href, window.location.origin);
      if (url.pathname === window.location.pathname && url.hash) {
        return document.querySelector(url.hash);
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function initFadeUp(wrap) {
    var animated = wrap.querySelectorAll('.bn-cph__animate');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = wrap.getAttribute('data-bn-cph-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initAnchorLinks(wrap) {
    wrap.querySelectorAll('[data-bn-cph-anchor]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        var target = resolveHashTarget(href);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'start'
        });

        var hash = href.charAt(0) === '#' ? href : new URL(href, window.location.origin).hash;
        if (hash) {
          history.replaceState(null, '', hash);
        }
      });
    });
  }

  function initWrap(wrap) {
    if (!wrap || wrap.dataset.bnCphInit === 'true') return;
    wrap.dataset.bnCphInit = 'true';

    initFadeUp(wrap);
    initAnchorLinks(wrap);
  }

  function initAll() {
    document.querySelectorAll('[data-bn-cph-wrap]').forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var wrap = event.target.querySelector('[data-bn-cph-wrap]');
    if (wrap) initWrap(wrap);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var wrap = event.target.querySelector('[data-bn-cph-wrap]');
    if (wrap) {
      delete wrap.dataset.bnCphInit;
    }
  });
})();
